import { utils } from '@intrasync/utils';
import DialogContent from "@mui/material/DialogContent";
import { Suspense } from "react";

import injectStores from "components/RootStore/injectStores";
import { ErrorBoundary } from "components/ErrorBoundary";
import componentFromLazy from "components/Lazy/ComponentFromLazy";
import type { RouterStore } from "stores/RouterStore";

interface DialogBodyProps {
  dividers?: boolean;
  height?: number;
  routerStore?: RouterStore;
}

const DialogBody = injectStores((props: DialogBodyProps) => {
  const { dividers, height = 400, routerStore } = props;
  if (!routerStore) return null;
  const { renderDialog } = routerStore;
  if (!renderDialog || !renderDialog.component) return null;
  const Component = componentFromLazy(
    renderDialog.component as unknown as Promise<{
      default: React.ComponentType<unknown>;
    }>
  );
  // console.log('Component', Component);

  return (
    <DialogContent
      sx={{
        height: renderDialog?.height ? renderDialog.height : height,
        padding: "12px",
      }}
      id={utils.uuid()}
      dividers={dividers}
    >
      <Suspense fallback={<div style={{ height: height }}>Loading...</div>}>
        <ErrorBoundary name="DialogBodyContent">
          <Component />
        </ErrorBoundary>
      </Suspense>
    </DialogContent>
  );
});

export default DialogBody;
